import { userEmailHydrator } from '../../fieldOptions/hydrators'

export default [{
  name: 'User 1',
  prop: 'user_id_low',
  type: 'autocomplete',
  dataHydrator: userEmailHydrator,
  references: 'admin/users',
  referenceProp: 'fullname',
  displayProp: 'displayVal'
}, {
  name: 'User 2',
  prop: 'user_id_high',
  type: 'autocomplete',
  dataHydrator: userEmailHydrator,
  references: 'admin/users',
  referenceProp: 'fullname',
  displayProp: 'displayVal'
}]
